// Central content + business data for Beauty By Magdalena.
// Single source of truth so the address, phone and service names stay
// byte-identical across header, footer, schema and map.

export const BUSINESS = {
  brand: "Beauty By Magdalena",
  // Byte-identical address string used EVERYWHERE (header, footer, schema, map).
  address: "Storgata 53F, 0182 Oslo",
  street: "Storgata 53F",
  postalCode: "0182",
  city: "Oslo",
  region: "Oslo",
  countryCode: "NO",
  countryName: { no: "Norge", en: "Norway" },
  geo: { lat: 59.9166, lng: 10.753 },
  phoneWhatsApp: "4793978992",
  phoneDisplay: "+47 93 97 89 92",
  orgnr: "936 215 270",
  email: "Niculaemadalinaa@yahoo.com",
  domain: "beautybymagdalena.net",
  url: "https://beautybymagdalena.net",
  hours: { open: "13:00", close: "20:00" },
};

// Google Maps embed for the exact address (byte-identical query string).
export const MAP_EMBED_SRC =
  "https://www.google.com/maps?q=Storgata%2053F%2C%200182%20Oslo&output=embed";
export const MAP_LINK =
  "https://www.google.com/maps/search/?api=1&query=Storgata%2053F%2C%200182%20Oslo";

// ---------------------------------------------------------------------------
// Services  (EXACTLY these four - do NOT add treatments the salon doesn't offer)
// ---------------------------------------------------------------------------
export const SERVICES = [
  {
    key: "pedicure",
    cluster: false,
    fromPrice: 780,
    hasPricing: true,
    no: {
      name: "Fotpleie \u2013 Profesjonell pedikyr",
      short: "Fotpleie",
      desc:
        "Grundig fotpleie med neglestell, fjerning av hard hud og pleiende avslutning. Fotbad, forming og lakk etter \u00f8nske.",
    },
    en: {
      name: "Pedicure \u2013 Professional foot care",
      short: "Pedicure",
      desc:
        "Thorough foot treatment including nail care, callus removal and a nourishing finish. Foot soak, shaping and polish on request.",
    },
    keywords: {
      no: ["fotpleie Oslo", "pedikyr Oslo", "fotpleie Storgata"],
      en: ["pedicure Oslo", "foot care Oslo"],
    },
  },
  {
    key: "waxing",
    cluster: false,
    fromPrice: 150,
    hasPricing: true,
    no: {
      name: "Voksing \u2013 hele kroppen",
      short: "Voksing",
      desc:
        "Sk\u00e5nsom h\u00e5rfjerning for hele kroppen med profesjonell voks. Glatt resultat som varer i uker.",
    },
    en: {
      name: "Full body waxing",
      short: "Waxing",
      desc:
        "Gentle full body hair removal with professional wax. Smooth results that last for weeks.",
    },
    keywords: {
      no: ["voksing Oslo", "h\u00e5rfjerning Oslo", "helkroppsvoksing Oslo"],
      en: ["waxing Oslo", "full body waxing Oslo", "hair removal Oslo"],
    },
  },
  {
    key: "lash-brow-tint",
    cluster: true,
    fromPrice: 220,
    hasPricing: true,
    no: {
      name: "Farging av vipper og bryn",
      short: "Farging vipper og bryn",
      desc:
        "Farging som gir dypere, tydeligere blikk uten daglig sminke. Vipper og bryn tilpasset din naturlige tone.",
    },
    en: {
      name: "Lash and brow tinting",
      short: "Lash & brow tinting",
      desc:
        "Tinting for a deeper, more defined look without daily makeup. Lashes and brows matched to your natural tone.",
    },
    keywords: {
      no: ["vippefarging Oslo", "brynfarging Oslo", "farging vipper bryn Oslo"],
      en: ["lash tinting Oslo", "brow tinting Oslo", "eyelash tint Oslo"],
    },
  },
  {
    key: "brow-shaping",
    cluster: true,
    fromPrice: 250,
    hasPricing: true,
    no: {
      name: "Brynsforming",
      short: "Brynsforming",
      desc:
        "Presis forming av bryn tilpasset ansiktsform. Rene linjer og en naturlig, balansert bue.",
    },
    en: {
      name: "Brow shaping",
      short: "Brow shaping",
      desc:
        "Precise brow shaping tailored to your face shape. Clean lines and a natural, balanced arch.",
    },
    keywords: {
      no: ["brynsforming Oslo", "forming av bryn Oslo", "bryn Oslo"],
      en: ["brow shaping Oslo", "eyebrow shaping Oslo"],
    },
  },
];

// Served areas for local SEO (Oslo Sentrum).
export const SERVED_AREAS = [
  "Sentrum",
  "Gr\u00fcnerl\u00f8kka",
  "Gamlebyen",
  "Hausmannskvartalet",
  "Youngstorget",
  "Jernbanetorget",
];

export const IMAGES = {
  logo: "logo.png",
  hero:
    "https://images.unsplash.com/photo-1639246928034-083c18eabd82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBiZWF1dHklMjBzYWxvbiUyMGRhcmslMjBpbnRlcmlvciUyMGdvbGQlMjBhY2NlbnRzfGVufDB8fHxibGFja3wxNzg3NDAzMjQ0fDA&ixlib=rb-4.1.0&q=85",
  product1:
    "https://images.unsplash.com/photo-1633793566189-8e9fe6f817fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBza2luY2FyZSUyMHByb2R1Y3QlMjBkYXJrJTIwYmFja2dyb3VuZCUyMGdvbGR8ZW58MHx8fGJsYWNrfDE3ODc0MDMyNTB8MA&ixlib=rb-4.1.0&q=85",
  product2:
    "https://images.unsplash.com/photo-1633793566023-a74b74104acb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBza2luY2FyZSUyMHByb2R1Y3QlMjBkYXJrJTIwYmFja2dyb3VuZCUyMGdvbGR8ZW58MHx8fGJsYWNrfDE3ODc0MDMyNTB8MA&ixlib=rb-4.1.0&q=85",
  oslo:
    "https://images.unsplash.com/photo-1638694749039-b1b55d8048f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxvc2xvJTIwY2l0eSUyMG5pZ2h0JTIwc3RyZWV0JTIwZWxlZ2FudHxlbnwwfHx8YmxhY2t8MTc4NzQwMzI1NXww&ixlib=rb-4.1.0&q=85",
};

// Guaranteed-good fallback (verified to load) used by ImageWithFallback.
export const IMAGE_FALLBACK = IMAGES.product1;

// Before/After gallery (DEMO stock imagery – to be replaced with the salon's
// own before/after photos). Non-verified URLs fall back to a verified image.
export const GALLERY = {
  featured: {
    before: "gallery-before.jpg",
    after: "gallery-after-2.jpg",
  },
  grid: [
    { src: "gallery-1.jpg" },
    { src: "gallery-10.jpg" },
    { src: "gallery-9.jpg" },
    { src: "gallery-11.jpg" },
    { src: "gallery-6.jpg" },
    { src: "gallery-12.jpg" },
  ],
};

// Instagram section (DEMO grid + follow link). Swap handle/url for the real
// account and drop in a live widget script later. Images use fallback safety.
export const INSTAGRAM = {
  handle: "beauty_by_magdalena88",
  url: "https://www.instagram.com/beauty_by_magdalena88/",
  // Live feed widget (e.g. Behold/Elfsight embed URL). When set, the section
  // renders the live Instagram grid instead of the static image grid below.
  widgetUrl: null,  images: [
    { src: IMAGES.product1 },
    { src: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?auto=format&fit=crop&w=600&q=80" },
    { src: IMAGES.product2 },
    { src: "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?auto=format&fit=crop&w=600&q=80" },
    { src: IMAGES.hero },
    { src: "https://images.unsplash.com/photo-1522337660859-02fbefca2e21?auto=format&fit=crop&w=600&q=80" },
    { src: IMAGES.oslo },
    { src: "https://images.unsplash.com/photo-1519415387722-a1c3bdc19ffb?auto=format&fit=crop&w=600&q=80" },
  ],
};

// ---------------------------------------------------------------------------
// Waxing (Voksing) price list \u2013 real prices provided by the salon.
// Norwegian names are authoritative; English is a helpful translation.
// ---------------------------------------------------------------------------
export function formatKr(n) {
  // 1050 -> "1\u00a0050 kr" (Norwegian thousands separator = non-breaking space)
  const grouped = new Intl.NumberFormat("nb-NO").format(n);
  return `${grouped} kr`;
}

export const WAXING_SIGNATURE = [580, 840, 1500, 1800];

export const WAXING_SINGLES = [
  { key: "brazilian", no: "Brasiliansk", en: "Brazilian", price: 580 },
  { key: "bikini-line", no: "Bikinilinje", en: "Bikini line", price: 350 },
  { key: "extended-bikini", no: "Utvidet bikini", en: "Extended bikini", price: 450 },
  { key: "underarms", no: "Armhuler", en: "Underarms", price: 190 },
  { key: "lower-legs", no: "Legger", en: "Lower legs", price: 270 },
  { key: "thighs", no: "L\u00e5r", en: "Thighs", price: 280 },
  { key: "full-legs", no: "Hele ben", en: "Full legs", price: 520 },
  { key: "half-arms", no: "Halve armer", en: "Half arms", price: 270 },
  { key: "full-arms", no: "Hele armer", en: "Full arms", price: 350 },
  { key: "upper-lip", no: "Overleppe", en: "Upper lip", price: 160 },
  { key: "chin", no: "Hake", en: "Chin", price: 160 },
  { key: "nose", no: "Nese", en: "Nose", price: 150 },
  { key: "eyebrows", no: "\u00d8yenbryn", en: "Eyebrows", price: 170 },
  { key: "face", no: "Ansikt", en: "Face", price: 520 },
  { key: "stomach", no: "Mage", en: "Stomach", price: 250 },
  { key: "buttocks", no: "Rumpe", en: "Buttocks", price: 250 },
  { key: "back", no: "Rygg", en: "Back", price: 390 },
];

// Combo packages. `parts` reference single keys so we can compute the saving.
export const WAXING_COMBOS = [
  { key: "c-bra-arm", no: "Brasiliansk + armhuler", en: "Brazilian + underarms", price: 680, parts: ["brazilian", "underarms"] },
  { key: "c-bra-legger", no: "Brasiliansk + legger", en: "Brazilian + lower legs", price: 720, parts: ["brazilian", "lower-legs"] },
  { key: "c-bra-legger-arm", no: "Brasiliansk + legger + armhuler", en: "Brazilian + lower legs + underarms", price: 840, featured: true, parts: ["brazilian", "lower-legs", "underarms"] },
  { key: "c-bra-heleben", no: "Brasiliansk + hele ben", en: "Brazilian + full legs", price: 950, parts: ["brazilian", "full-legs"] },
  { key: "c-bra-heleben-arm", no: "Brasiliansk + hele ben + armhuler", en: "Brazilian + full legs + underarms", price: 1050, parts: ["brazilian", "full-legs", "underarms"] },
  { key: "c-bik-arm", no: "Bikinilinje + armhuler", en: "Bikini line + underarms", price: 450, parts: ["bikini-line", "underarms"] },
  { key: "c-bik-legger", no: "Bikinilinje + legger", en: "Bikini line + lower legs", price: 550, parts: ["bikini-line", "lower-legs"] },
  { key: "c-bik-legger-arm", no: "Bikinilinje + legger + armhuler", en: "Bikini line + lower legs + underarms", price: 690, parts: ["bikini-line", "lower-legs", "underarms"] },
  { key: "c-bik-heleben", no: "Bikinilinje + hele ben", en: "Bikini line + full legs", price: 790, parts: ["bikini-line", "full-legs"] },
  { key: "c-heleben-arm", no: "Hele ben + armhuler", en: "Full legs + underarms", price: 620, parts: ["full-legs", "underarms"] },
];

export const WAXING_SEASONAL = [
  {
    key: "autumn-pass",
    no: "Autumn Pass",
    en: "Autumn Pass",
    detail_no: "3 \u00d7 Brasiliansk",
    detail_en: "3 \u00d7 Brazilian",
    price: 1500,
    regular: 1740,
    perUnit_no: "500 kr per behandling",
    perUnit_en: "500 kr per treatment",
    months_no: ["September", "Oktober", "November"],
    months_en: ["September", "October", "November"],
  },
  {
    key: "autumn-vip",
    no: "Autumn VIP",
    en: "Autumn VIP",
    detail_no: "3 \u00d7 Brasiliansk + armhuler",
    detail_en: "3 \u00d7 Brazilian + underarms",
    price: 1800,
    regular: 2310,
    perUnit_no: "600 kr per bes\u00f8k",
    perUnit_en: "600 kr per visit",
    featured: true,
    months_no: ["September", "Oktober", "November"],
    months_en: ["September", "October", "November"],
  },
];

export const WAXING_TERMS = {
  no: "Betales ved f\u00f8rste behandling. Personlig pakke som ikke kan overf\u00f8res til andre. \u00c9n behandling per m\u00e5ned. Pakkeprisen kan ikke kombineres med andre tilbud.",
  en: "Paid at the first treatment. Personal package that cannot be transferred to others. One treatment per month. The package price cannot be combined with other offers.",
};

// Helper: sum of the single-area prices that make up a combo.
export function comboRegularPrice(parts) {
  return parts.reduce((sum, k) => {
    const s = WAXING_SINGLES.find((x) => x.key === k);
    return sum + (s ? s.price : 0);
  }, 0);
}

// ---------------------------------------------------------------------------
// Pedicure price list – real prices provided by the salon.
// ---------------------------------------------------------------------------
export const PEDICURE_PRICES = [
  { key: "ped-shellac", no: "Pedikyr med Shellac", en: "Pedicure with Shellac", price: 890 },
  { key: "ped-spa", no: "SPA-pedikyr", en: "SPA pedicure", price: 780 },
  { key: "ped-spa-shellac", no: "SPA-pedikyr med Shellac", en: "SPA pedicure with Shellac", price: 980, featured: true },
];

// ---------------------------------------------------------------------------
// Brows & lashes price list – real prices provided by the salon.
// ---------------------------------------------------------------------------
export const LASHBROW_PRICES = [
  { key: "lb-brow-forming", no: "Forming av bryn", en: "Brow shaping", price: 250 },
  { key: "lb-brow-tint", no: "Farging av bryn", en: "Brow tint", price: 220 },
  { key: "lb-brow-form-tint", no: "Forming + farging av bryn", en: "Brow shaping + tint", price: 390 },
  { key: "lb-lash-tint", no: "Farging av vipper", en: "Lash tint", price: 250 },
  { key: "lb-brow-lash-tint", no: "Farging av bryn + vipper", en: "Brow + lash tint", price: 390 },
  { key: "lb-full", no: "Forming + farging av bryn + farging av vipper", en: "Brow shaping + tint + lash tint", price: 490, featured: true },
];

// ---------------------------------------------------------------------------
// Client reviews (same data as backend INITIAL_REVIEWS). Used as fallback
// when the API is unreachable (e.g. static hosting without backend), so the
// section always renders. Kept in sync with backend/server.py.
// ---------------------------------------------------------------------------
export const REVIEWS_STATIC = [
  {
    id: "static-1",
    name: "Emma N.",
    rating: 5,
    text_no: "Veldig fornøyd! Kommer absolutt tilbake.",
    text_en: "Very happy! Will absolutely be back.",
    source: "Kunde",
  },
  {
    id: "static-2",
    name: "Sofie L.",
    rating: 5,
    text_no: "Kjempebra behandling og veldig hyggelig service. Magdalena er utrolig flink!",
    text_en: "Great treatment and really lovely service. Magdalena is incredibly skilled!",
    source: "Kunde",
  },
  {
    id: "static-3",
    name: "Ingrid H.",
    rating: 5,
    text_no: "Jeg hadde en veldig fin opplevelse hos Beauty By Magdalena. Behandlingen var skånsom, og resultatet ble akkurat slik jeg håpet.",
    text_en: "I had a really lovely experience at Beauty By Magdalena. The treatment was gentle, and the result was exactly what I hoped for.",
    source: "Kunde",
  },
  {
    id: "static-4",
    name: "Nora B.",
    rating: 5,
    text_no: "Superfornøyd med resultatet!",
    text_en: "Super happy with the result!",
    source: "Kunde",
  },
  {
    id: "static-5",
    name: "Maja S.",
    rating: 5,
    text_no: "Så hyggelig sted, og Magdalena er veldig profesjonell. Følte meg trygg og godt ivaretatt hele veien.",
    text_en: "Such a lovely place, and Magdalena is very professional. I felt safe and well looked after the whole way.",
    source: "Kunde",
  },
  {
    id: "static-6",
    name: "Ida K.",
    rating: 5,
    text_no: "Anbefales! Veldig fornøyd med voksingen.",
    text_en: "Recommended! Very happy with the waxing.",
    source: "Kunde",
  },
  {
    id: "static-7",
    name: "Amalie R.",
    rating: 5,
    text_no: "Dette var mitt første besøk, og jeg ble positivt overrasket. Veldig behagelig behandling og et kjempefint resultat.",
    text_en: "This was my first visit, and I was positively surprised. Very comfortable treatment and a great result.",
    source: "Kunde",
  },
  {
    id: "static-8",
    name: "Thea M.",
    rating: 5,
    text_no: "Utrolig flink og nøye. Jeg er veldig fornøyd!",
    text_en: "Incredibly skilled and thorough. I'm very happy!",
    source: "Kunde",
  },
  {
    id: "static-9",
    name: "Julie A.",
    rating: 5,
    text_no: "Elsket resultatet! Huden føles så myk og glatt etterpå.",
    text_en: "Loved the result! My skin feels so soft and smooth afterwards.",
    source: "Kunde",
  },
  {
    id: "static-10",
    name: "Selma E.",
    rating: 5,
    text_no: "Veldig profesjonelt og hyggelig. Kommer gjerne tilbake.",
    text_en: "Very professional and friendly. Happy to come back.",
    source: "Kunde",
  },
  {
    id: "static-11",
    name: "Victoria T.",
    rating: 5,
    text_no: "Jeg har prøvd flere steder tidligere, men er virkelig fornøyd med behandlingen her. Magdalena er nøye og veldig behagelig å være hos.",
    text_en: "I have tried several places before, but I'm really happy with the treatment here. Magdalena is thorough and very pleasant to be around.",
    source: "Kunde",
  },
  {
    id: "static-12",
    name: "Sara J.",
    rating: 5,
    text_no: "Kjempefornøyd ❤️",
    text_en: "Really happy ❤️",
    source: "Kunde",
  },
  {
    id: "static-13",
    name: "Linnea P.",
    rating: 5,
    text_no: "Nydelig salong og fantastisk service. Behandlingen gikk veldig fint, og jeg følte meg komfortabel hele tiden.",
    text_en: "Beautiful salon and fantastic service. The treatment went very well, and I felt comfortable the whole time.",
    source: "Kunde",
  },
  {
    id: "static-14",
    name: "Hanna V.",
    rating: 5,
    text_no: "Veldig fornøyd med voksbehandlingen. Raskt, pent og profesjonelt utført.",
    text_en: "Very happy with the waxing treatment. Quick, neat and professionally done.",
    source: "Kunde",
  },
  {
    id: "static-15",
    name: "Ella G.",
    rating: 5,
    text_no: "Så fornøyd! Kommer definitivt tilbake neste gang.",
    text_en: "So happy! Definitely coming back next time.",
    source: "Kunde",
  },
  {
    id: "static-16",
    name: "Oda F.",
    rating: 5,
    text_no: "Magdalena er utrolig hyggelig og flink i det hun gjør. Jeg ble veldig fornøyd med resultatet og anbefaler henne gjerne videre.",
    text_en: "Magdalena is incredibly kind and skilled at what she does. I'm very happy with the result and gladly recommend her.",
    source: "Kunde",
  },
  {
    id: "static-17",
    name: "Martine D.",
    rating: 5,
    text_no: "Fantastisk resultat!",
    text_en: "Fantastic result!",
    source: "Kunde",
  },
  {
    id: "static-18",
    name: "Celine W.",
    rating: 5,
    text_no: "Veldig god opplevelse fra start til slutt. Profesjonell behandling og en rolig, fin atmosfære.",
    text_en: "A very good experience from start to finish. Professional treatment and a calm, lovely atmosphere.",
    source: "Kunde",
  },
  {
    id: "static-19",
    name: "Tuva I.",
    rating: 5,
    text_no: "Dette ble bedre enn forventet. Veldig fornøyd med både servicen og resultatet!",
    text_en: "This turned out better than expected. Very happy with both the service and the result!",
    source: "Kunde",
  },
  {
    id: "static-20",
    name: "Karoline R.",
    rating: 5,
    text_no: "Første gang hos Beauty By Magdalena, og jeg kommer helt klart tilbake. Veldig hyggelig og profesjonell behandling.",
    text_en: "First time at Beauty By Magdalena, and I will definitely be back. Very friendly and professional treatment.",
    source: "Kunde",
  },
];
